import { lazy } from "react";

const Informations = lazy(() => import("./Informations"));
const Preferences = lazy(() => import("./Preferences"));
const Paiements = lazy(() => import("./Paiements"));
const Theme = lazy(() => import("./Theme"));
const AgenceInfo=lazy(()=>import("./AgenceInfo"));

const SettingsRoutes = [
  {
    path: "/settings/information",
    element: <Informations />,
  },
  {
    path: "/settings/preferences",
    element: <Preferences />,
  },
  {
    path: "/settings/paiements",
    element: <Paiements />,
  },
  {
    path: "/settings/theme",
    element: <Theme />,
  },
  {
    path: "/settings/AgenceInfo",
    element: <AgenceInfo />,
  },
  
 
];

export default SettingsRoutes;
